<template>
  <transition name="toast-fade">
    <div v-if="show" class="toast-overlay">
      <div class="toast-container">
        <!-- 流星效果 -->
        <div class="meteor meteor-1"></div>
        <div class="meteor meteor-2"></div>
        <div class="meteor meteor-3"></div>

        <!-- 星球图标 -->
        <div class="planet-icon">
          <div class="planet">
            <div class="planet-ring"></div>
            <div class="planet-surface"></div>
          </div>
          <!-- 成功标记 -->
          <div class="check-mark">
            <svg viewBox="0 0 52 52">
              <circle class="check-circle" cx="26" cy="26" r="25" fill="none" />
              <path
                class="check-path"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
        </div>

        <!-- 提示文字 -->
        <div class="toast-message">
          <div class="message-title">链接已复制到星际剪贴板</div>
          <div class="message-subtitle">{{ copiedUrl }}</div>
        </div>

        <!-- 星星装饰 -->
        <div class="sparkles">
          <div class="sparkle sparkle-1"></div>
          <div class="sparkle sparkle-2"></div>
          <div class="sparkle sparkle-3"></div>
          <div class="sparkle sparkle-4"></div>
          <div class="sparkle sparkle-5"></div>
          <div class="sparkle sparkle-6"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CopyToast",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    copiedUrl: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
/* Toast 遮罩 */
.toast-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  pointer-events: none;
}

.toast-fade-enter-active {
  animation: toast-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.toast-fade-leave-active {
  animation: toast-out 0.4s ease-in;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-100px);
  }
  50% {
    transform: scale(1.05) translateY(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes toast-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(50px);
  }
}

/* Toast 容器 */
.toast-container {
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(249, 250, 251, 0.95) 100%
  );
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 2rem 2.5rem;
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.3),
    0 0 0 1px rgba(102, 126, 234, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  min-width: 320px;
  max-width: 500px;
  overflow: hidden;
  animation: container-glow 2s ease-in-out infinite;
}

@keyframes container-glow {
  0%,
  100% {
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.3),
      0 0 0 1px rgba(102, 126, 234, 0.1);
  }
  50% {
    box-shadow: 0 20px 60px rgba(118, 75, 162, 0.4),
      0 0 0 1px rgba(118, 75, 162, 0.2), 0 0 40px rgba(102, 126, 234, 0.2);
  }
}

/* 流星效果 */
.meteor {
  position: absolute;
  width: 2px;
  height: 80px;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(102, 126, 234, 0.8),
    transparent
  );
  border-radius: 50%;
  animation: meteor-fall 1.5s ease-out;
  opacity: 0;
}

.meteor-1 {
  top: -80px;
  left: 20%;
  animation-delay: 0.1s;
  transform: rotate(-25deg);
}

.meteor-2 {
  top: -80px;
  left: 50%;
  animation-delay: 0.3s;
  transform: rotate(-30deg);
}

.meteor-3 {
  top: -80px;
  right: 20%;
  animation-delay: 0.5s;
  transform: rotate(-35deg);
}

@keyframes meteor-fall {
  0% {
    opacity: 0;
    transform: translateY(0) translateX(0) rotate(-25deg);
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
    transform: translateY(200px) translateX(100px) rotate(-25deg);
  }
}

/* 星球图标 */
.planet-icon {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.planet {
  position: relative;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  border-radius: 50%;
  box-shadow: inset -5px -5px 15px rgba(0, 0, 0, 0.2),
    inset 5px 5px 10px rgba(255, 255, 255, 0.3),
    0 10px 30px rgba(102, 126, 234, 0.4);
  animation: planet-float 3s ease-in-out infinite;
}

.planet-surface {
  position: absolute;
  inset: 0;
  background: radial-gradient(
      circle at 30% 30%,
      rgba(255, 255, 255, 0.3) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 70%,
      rgba(118, 75, 162, 0.3) 0%,
      transparent 40%
    );
  border-radius: 50%;
}

.planet-ring {
  position: absolute;
  width: 90px;
  height: 30px;
  border: 3px solid rgba(240, 147, 251, 0.6);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(75deg);
  box-shadow: 0 0 20px rgba(240, 147, 251, 0.4);
  animation: ring-rotate 4s linear infinite;
}

@keyframes planet-float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
  }
}

@keyframes ring-rotate {
  0% {
    transform: translate(-50%, -50%) rotateX(75deg) rotateZ(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotateX(75deg) rotateZ(360deg);
  }
}

/* 成功标记 */
.check-mark {
  position: absolute;
  width: 35px;
  height: 35px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.check-mark svg {
  width: 100%;
  height: 100%;
}

.check-circle {
  stroke: #ffffff;
  stroke-width: 3;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: check-circle-anim 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;
}

.check-path {
  stroke: #ffffff;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: check-path-anim 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

@keyframes check-circle-anim {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes check-path-anim {
  to {
    stroke-dashoffset: 0;
  }
}

/* 提示文字 */
.toast-message {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message-title {
  font-size: 1.125rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
  animation: text-shimmer 2s ease-in-out infinite;
}

.message-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes text-shimmer {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* 星星装饰 */
.sparkles {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.sparkle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: linear-gradient(135deg, #667eea, #f093fb);
  border-radius: 50%;
  box-shadow: 0 0 10px currentColor;
  animation: sparkle-twinkle 1.5s ease-in-out infinite;
}

.sparkle-1 {
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.sparkle-2 {
  top: 20%;
  right: 15%;
  animation-delay: 0.3s;
}

.sparkle-3 {
  bottom: 20%;
  left: 15%;
  animation-delay: 0.6s;
}

.sparkle-4 {
  bottom: 25%;
  right: 10%;
  animation-delay: 0.9s;
}

.sparkle-5 {
  top: 50%;
  left: 5%;
  animation-delay: 0.2s;
  width: 3px;
  height: 3px;
}

.sparkle-6 {
  top: 55%;
  right: 5%;
  animation-delay: 0.5s;
  width: 3px;
  height: 3px;
}

@keyframes sparkle-twinkle {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.5) rotate(180deg);
  }
}

/* 响应式 */
@media (max-width: 640px) {
  .toast-container {
    min-width: 280px;
    padding: 1.5rem 2rem;
  }

  .planet-icon {
    width: 70px;
    height: 70px;
  }

  .planet {
    width: 50px;
    height: 50px;
  }

  .planet-ring {
    width: 75px;
    height: 25px;
  }

  .check-mark {
    width: 30px;
    height: 30px;
  }

  .message-title {
    font-size: 1rem;
  }

  .message-subtitle {
    font-size: 0.8125rem;
  }
}
</style>
